/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Show_AllInputs */

const cs_documents_show_all = /** @type {(inputs: Documents_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit všechny složky`)
};

const en_documents_show_all = /** @type {(inputs: Documents_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show all folders`)
};

/**
* | output |
* | --- |
* | "Show all folders" |
*
* @param {Documents_Show_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_show_all = /** @type {((inputs?: Documents_Show_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Show_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_show_all(inputs)
	return cs_documents_show_all(inputs)
});